<template>
  <template v-if="!isLoading && address">
    <div class="default-address" v-if="address && address.length > 0">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <label for="language" class="form-label">{{ $t('DefaultAddress') }}</label>
          <select class="form-select" v-model="defaultAddress" :disabled="isAppendAnotherAddress">
            <option disabled selected value="">{{ $t('SelectDefaultAddress') }}</option>
            <option :value="obj.id" v-for="obj in address" :key="obj.id">
              {{ obj.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="mt-3"></div>
    </div>
    <div class="address" id="address-{{ address.id }}" :class="index === address.length - 1 ? 'addressLast' : ''" v-for="(obj, index) in address" :key="obj.id">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <label for="name" class="form-label">{{ $t('NameProfile') }}</label>
          <input type="text"
                 v-model="obj.name"
                 name="name"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="name"
                 autocomplete="key-name-{{ obj.id }}"
                 :disabled="isAppendAnotherAddress"
          >
        </div>
        <div class="col-lg-6 mb-3">
          <div class="address__remove">
            <div v-if="!isAppendAnotherAddress" class="address__remove__icon" data-address="{{ obj.id }}"
                 @click="this.removeAddress(obj.id)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                   class="bi bi-trash3" viewBox="0 0 16 16">
                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5
                0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2
                2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0
                0 0-.01 0zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487
                1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5
                0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0
                0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 mb-3">
          <template v-if="obj.isManualSelectedCity">
            <div class="form-label-wrapper">
              <label for="city" class="form-label">
                {{ $t('City') }}
              </label>
              <span class="labelAction" @click="listSelectedCity(obj.id)">
                {{ $t('listSelect') }}
              </span>
            </div>
            <input type="text"
                   v-model="obj.city"
                   name="city"
                   class="form-control input-dirty"
                   placeholder=""
                   aria-describedby="city"
                   autocomplete="key-city-{{ obj.id }}"
                   @input="setCityInput(obj.id, $event.target.value)"
                   :disabled="isAppendAnotherAddress"
            >
          </template>
          <template v-else>
            <div class="form-label-wrapper">
              <label for="city" class="form-label">
                {{ $t('City') }}
              </label>
              <span class="labelAction" @click="manualSelectedCity(obj.id)">
                {{ $t('manualSelect') }}
              </span>
            </div>
            <Select2 name="selectRoute"
               v-model="obj.select2City"
               :options="obj.selectCityOptions"
               :multiple="false"
               :disabled="isAppendAnotherAddress"
               :settings="{
                   language: {
                     noResults: function () {
                       return $t('noResultsFound');
                     },
                     inputTooShort: function() {
                       return $t('alertMinInputTooShort');
                     },
                     searching: function (){
                       return $t('searching');
                     },
                     loadingMore: function (){
                        return $t('loadingMore');
                     },
                     errorLoading: function (){
                        return $t('errorLoading');
                     },
                   },
                   minimumInputLength: 1,
                   placeholder: $t('selectCity'),
                   ajax: {
                     url: '/dashboard/api/address/routes',
                     delay: 250,
                     dataType: 'json',
                     data: function (params) {
                       return {
                         search: params.term
                       };
                     },
                     processResults: function (data) {
                       return {
                         results: data.results.map((item) => ({
                           id: item.id,
                           text: item.title,
                           ref: item.city && item.city.ref_city ? item.city.ref_city.ref : null,
                         }))
                       };
                     },
                   },
                  }"
                   @select="selectCitySelectEvent($event, obj.id)"/>
          </template>
        </div>
        <div class="col-lg-4 mb-3">
          <template v-if="obj.isManualSelectedStreet">
            <div class="form-label-wrapper">
              <label for="street" class="form-label">{{ $t('Street') }}</label>
              <span class="labelAction" @click="listSelectedStreet(obj.id)">
                {{ $t('listSelect') }}
              </span>
            </div>
            <input type="text"
                   v-model="obj.street"
                   name="street"
                   class="form-control input-dirty"
                   placeholder=""
                   aria-describedby="street"
                   autocomplete="key-street-{{ obj.id }}"
                   @input="setStreetInput(obj.id, $event.target.value)"
                   :disabled="isAppendAnotherAddress"
            >
          </template>
          <template v-else>
            <div class="form-label-wrapper">
              <label for="street" class="form-label">{{ $t('Street') }}</label>
              <span class="labelAction" @click="manualSelectedStreet(obj.id)">
                {{ $t('manualSelect') }}
              </span>
            </div>
            <Select2 name="selectStreet"
               v-model="obj.select2Street"
               :options="obj.selectStreetOptions"
               :multiple="false"
               :disabled="isAppendAnotherAddress"
               :settings="{
                   language: {
                     noResults: function () {
                       return $t('noResultsFound');
                     },
                     inputTooShort: function() {
                       return $t('alertMinInputTooShort');
                     },
                     searching: function (){
                       return $t('searching');
                     },
                     loadingMore: function (){
                        return $t('loadingMore');
                     },
                     errorLoading: function (){
                        return $t('errorLoading');
                     },
                   },
                   minimumInputLength: 1,
                   placeholder: $t('Street'),
                   ajax: {
                     url: '/dashboard/api/address/streets',
                     delay: 250,
                     dataType: 'json',
                     data: function (params) {
                       return {
                         search: params.term,
                         city_ref: obj.city_ref,
                       };
                     },
                     processResults: function (data) {
                       return {
                         results: data.results.data.map((item) => ({
                           id: item.Ref,
                           text: item.Description,
                         }))
                       };
                     },
                   },
                  }"
                   @select="selectStreetSelectEvent($event, obj.id)"/>
          </template>
        </div>
        <div class="col-lg-2 mb-3">
          <label for="house" class="form-label">{{ $t('House') }}</label>
          <input type="text"
                 v-model="obj.house"
                 name="house"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="house"
                 autocomplete="key-house-{{ obj.id }}"
                 @input="setHouseInput(obj.id, $event.target.value)"
                 :disabled="isAppendAnotherAddress"
          >
        </div>
        <div class="col-lg-2 mb-3">
          <label for="apartment" class="form-label">{{ $t('Apartment') }}</label>
          <input type="text"
                 v-model="obj.apartment"
                 name="apartment"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="apartment"
                 autocomplete="key-apartment-{{ obj.id }}"
                 @input="setApartmentInput(obj.id, $event.target.value)"
                 :disabled="isAppendAnotherAddress"
          >
        </div>
      </div>
    </div>
    <div class="address addressLast" v-if="isAppendAnotherAddress">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <label for="name" class="form-label">{{ $t('NameProfile') }}</label>
          <input type="text"
                 v-model="anotherAddress.name"
                 name="name"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="name"
                 autocomplete="key-name-append-address"
          >
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 mb-3">
          <template v-if="anotherAddress.isManualSelectedCity">
            <div class="form-label-wrapper">
              <label for="city" class="form-label">{{ $t('City') }}</label>
              <span class="labelAction"  @click="listSelectedCity(null)">{{ $t('listSelect') }}</span>
            </div>
            <input type="text"
                   v-model="anotherAddress.city"
                   name="city"
                   class="form-control input-dirty"
                   placeholder=""
                   aria-describedby="city"
                   autocomplete="key-city-append-address"
            >
          </template>
          <template v-else>
            <div class="form-label-wrapper">
              <label for="city" class="form-label">
                {{ $t('City') }}
              </label>
              <span class="labelAction" @click="manualSelectedCity(null)">
                {{ $t('manualSelect') }}
              </span>
            </div>
            <Select2 name="selectRoute"
               v-model="anotherAddress.select2City"
               :options="anotherAddress.selectCityOptions"
               :multiple="false"
               :settings="{
                   language: {
                     noResults: function () {
                       return $t('noResultsFound');
                     },
                     inputTooShort: function() {
                       return $t('alertMinInputTooShort');
                     },
                     searching: function (){
                       return $t('searching');
                     },
                     loadingMore: function (){
                        return $t('loadingMore');
                     },
                     errorLoading: function (){
                        return $t('errorLoading');
                     },
                   },
                   minimumInputLength: 1,
                   placeholder: $t('selectCity'),
                   ajax: {
                     url: '/dashboard/api/address/routes',
                     delay: 250,
                     dataType: 'json',
                     data: function (params) {
                       return {
                         search: params.term
                       };
                     },
                     processResults: function (data) {
                       return {
                         results: data.results.map((item) => ({
                           id: item.id,
                           text: item.title,
                           ref: item.city && item.city.ref_city ? item.city.ref_city.ref : null,
                         }))
                       };
                     },
                   },
                  }"
                   @select="selectCitySelectEvent($event)"/>
          </template>
        </div>
        <div class="col-lg-4 mb-3">
          <template v-if="anotherAddress.isManualSelectedStreet||anotherAddress.isManualSelectedCity">
            <div class="form-label-wrapper">
              <label for="street" class="form-label">{{ $t('Street') }}</label>
              <span class="labelAction"
                    @click="listSelectedStreet(null)"
                    v-if="!anotherAddress.isManualSelectedCity">{{ $t('listSelect') }}</span>
            </div>
            <input type="text"
                   v-model="anotherAddress.street"
                   name="street"
                   class="form-control input-dirty"
                   placeholder=""
                   aria-describedby="street"
                   autocomplete="key-street-append-address"
            >
          </template>
          <template v-else>
            <div class="form-label-wrapper">
              <label for="street" class="form-label">{{ $t('Street') }}</label>
              <span class="labelAction" @click="manualSelectedStreet(null)">
                {{ $t('manualSelect') }}
              </span>
            </div>
            <Select2 name="selectStreet"
               v-model="anotherAddress.select2Street"
               :options="anotherAddress.electStreetOptions"
               :multiple="false"
               :settings="{
                   language: {
                     noResults: function () {
                       return $t('noResultsFound');
                     },
                     inputTooShort: function() {
                       return $t('alertMinInputTooShort');
                     },
                     searching: function (){
                       return $t('searching');
                     },
                     loadingMore: function (){
                        return $t('loadingMore');
                     },
                     errorLoading: function (){
                        return $t('errorLoading');
                     },
                   },
                   minimumInputLength: 1,
                   placeholder: $t('Street'),
                   ajax: {
                     url: '/dashboard/api/address/streets',
                     delay: 250,
                     dataType: 'json',
                     data: function (params) {
                       return {
                         search: params.term,
                         city_ref: anotherAddress.city_ref,
                       };
                     },
                     processResults: function (data) {
                       return {
                         results: data.results.data.map((item) => ({
                           id: item.Ref,
                           text: item.Description,
                         }))
                       };
                     },
                   },
                  }"
                   @select="selectStreetSelectEvent($event)"/>
          </template>
        </div>
        <div class="col-lg-2 mb-3">
          <label for="house" class="form-label">{{ $t('House') }}</label>
          <input type="text"
                 v-model="anotherAddress.house"
                 name="house"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="house"
                 autocomplete="key-house-append-address"
          >
        </div>
        <div class="col-lg-2 mb-3">
          <label for="apartment" class="form-label">{{ $t('Apartment') }}</label>
          <input type="text"
                 v-model="anotherAddress.apartment"
                 name="apartment"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="apartment"
                 autocomplete="key-apartment-append-address"
          >
        </div>
      </div>
    </div>
    <div class="mt-4">
      <div class="address__addAnotherAddress" v-if="allowedAppendAnotherAddress && !isAppendAnotherAddress"
           @click="showAppendAnotherAddress">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
             class="bi bi-plus-lg" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1
          0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
        </svg>
        <div class="address__addAnotherAddress__label">
          {{ $t('AddAnotherAddress') }}
        </div>
      </div>
    </div>
    <div class="mt-4" v-if="isAppendAnotherAddress">
      <button class="btn btn-success" @click="createAddress" :disabled="isLoading">
        {{ $t('AddAddress') }}</button>
      <button type="button" @click="cancelAppendAnotherAddress"
              class="btn btn-secondary">{{ $t('Cancel') }}</button>
    </div>
    <div class="mt-4" v-if="!isAppendAnotherAddress">
      <button class="btn btn-success" :disabled="isLoading" @click="updateAddress">
        {{ $t('Save') }}
      </button>
      <button type="button"
              class="btn btn-secondary" @click="restoreUpdateAddress">
        {{ $t('Cancel') }}
      </button>
    </div>
  </template>
  <template v-else>
    <dashboard-local-preloader/>
  </template>
</template>

<script>
import Select2 from 'vue3-select2-component';
import DashboardLocalPreloader from "@/components/LocalPreloader.vue"

import {mapGetters} from "vuex";
import {actionTypes, mutationTypes, getterTypes} from "@/store/modules/address";

export default {
  name: 'DashboardAddress',
  components: {
    Select2,
    DashboardLocalPreloader,
  },
  mounted() {
    this.$store.commit(mutationTypes.clearAddress)
    this.$store.dispatch(actionTypes.getAddress).then((address) => {
      this.getDefaultAddress()

      address.forEach((item) => {
        if (!item.route){
          this.$store.commit(mutationTypes.setManualSelectedCity, {
            id: item.id,
            value: true
          })
          this.$store.commit(mutationTypes.setManualSelectedStreet, {
            id: item.id,
            value: true
          })
        } else {
          const select2CityOption = {id: item.route, text: item.city}
          this.$store.commit(mutationTypes.setSelect2City, {
            id: item.id,
            option: select2CityOption,
            option_id: item.route,
            ref: item.city_ref
          })

          const select2StreetOption = {id: 0, text: item.street}
          this.$store.commit(mutationTypes.setSelect2Street, {
            id: item.id,
            option: select2StreetOption,
            option_id: 0,
          })
        }
      })
    })
  },
  data(){
    return {
      logoTrash: require('@/assets/svg/trash3.svg'),
      defaultAddress: null,
      isAppendAnotherAddress: false,
      anotherAddress: {
        name: '',
        city: '',
        select2City: '',
        selectCityOptions: [],
        city_ref: null,
        route: '',
        street: '',
        select2Street: '',
        electStreetOptions: [],
        house: '',
        apartment: '',
        isManualSelectedCity: false,
        isManualSelectedStreet: false,
      },
      maxAddress: 5
    }
  },
  methods: {
    Notification(type, title, text){
      this.$notify({
        group: 'main',
        title: title,
        text: text,
        type: type,
        duration: 7000
      });
    },
    removeAddress(address_id){
      this.$store.dispatch(actionTypes.removeAddress, {id: address_id}).then(response => {
        if (response.status === 200){
          this.Notification(
              'success',
              this.$t('Successfully'),
              this.$t('ThisAddressHasBeenDeleted')
          )
        }
      }).then(() => {
        this.restoreUpdateAddress()
      })
    },
    showAppendAnotherAddress(){
      if (this.allowedAppendAnotherAddress){
        this.isAppendAnotherAddress = true
      } else {
        this.isAppendAnotherAddress = false
      }
    },
    cancelAppendAnotherAddress(){
      this.isAppendAnotherAddress = false
      this.clearAnotherAddress()
    },
    clearAnotherAddress(){
      this.anotherAddress.name = ''
      this.anotherAddress.city = ''
      this.anotherAddress.city_ref = null
      this.anotherAddress.street = ''
      this.anotherAddress.house = ''
      this.anotherAddress.apartment = ''
    },
    restoreUpdateAddress(){
      this.cancelAppendAnotherAddress()
      this.$store.commit(mutationTypes.clearAddress)
      this.$store.dispatch(actionTypes.getAddress).then((address) => {
        this.getDefaultAddress()

        // This code like as mount
        address.forEach((item) => {
        if (!item.route){
          this.$store.commit(mutationTypes.setManualSelectedCity, {
            id: item.id,
            value: true
          })
          this.$store.commit(mutationTypes.setManualSelectedStreet, {
            id: item.id,
            value: true
          })
        } else {
          const select2CityOption = {id: item.route, text: item.city}
          this.$store.commit(mutationTypes.setSelect2City, {
            id: item.id,
            option: select2CityOption,
            option_id: item.route,
            ref: item.city_ref
          })

          const select2StreetOption = {id: 0, text: item.street}
          this.$store.commit(mutationTypes.setSelect2Street, {
            id: item.id,
            option: select2StreetOption,
            option_id: 0,
          })
        }
      })
      })
    },
    createAddress(){
      this.$store.dispatch(actionTypes.createAddress, {
        name: this.anotherAddress.name,
        city: this.anotherAddress.city,
        route: this.anotherAddress.route,
        street: this.anotherAddress.street,
        house: this.anotherAddress.house,
        apartment: this.anotherAddress.apartment,
        is_default: false
      }).then(response => {
        if (response.status === 200){
          this.Notification(
              'success',
              this.$t('Successfully'),
              this.$t('ANewAddressHasBeenAdded')
          )
          this.restoreUpdateAddress()
        } else {
           this.Notification(
              'error',
              this.$t('Error'),
              this.$t('fillInTheAppropriateFields')
          )
        }
      })
    },
    async updateAddress() {
      await Promise.all(
        this.address.map((address) => {
          const isDefault = this.defaultAddress === address.id

          return this.$store.dispatch(actionTypes.updateAddress, {
            id: address.id,
            name: address.name,
            city: address.city,
            route: address.route,
            street: address.street,
            house: address.house,
            apartment: address.apartment,
            is_default: isDefault
          })
        })
      )

      this.restoreUpdateAddress()

      this.Notification(
        'success',
        this.$t('Successfully'),
        this.$t('AddressInformationHasBeenUpdated')
      )
    },
    getDefaultAddress(){
      if (this.address !== null) {
        this.address.forEach((obj) => {
          if (obj.is_default === true) {
            this.defaultAddress = obj.id
          }
        })
      }
    },
    selectCitySelectEvent({ id, text, ref }, obj_id=null) {
      console.log(`selectCitySelectEvent: ${id}, ${text}, ${ref}, ${obj_id}`);

      if (!obj_id){
        this.anotherAddress.city_ref = ref;

        this.anotherAddress.city = text;
        this.anotherAddress.route = id;
      } else {
        this.$store.commit(mutationTypes.setCity, {
          id: obj_id,
          rout_id: id,
          text: text,
          ref: ref,
        })
      }
    },
    selectStreetSelectEvent({ id, text }, obj_id=null) {
      console.log(`selectStreetSelectEvent: ${id}, ${text}`);

      if (!obj_id){
        this.anotherAddress.street = text;
      }  else {
        this.$store.commit(mutationTypes.setStreet, {
          id: obj_id,
          text: text,
        })
      }
    },
    manualSelectedCity(id){
      if (!id){
        this.anotherAddress.isManualSelectedCity = true;
      } else {
        this.$store.commit(mutationTypes.setManualSelectedCity, {
          id: id,
          value: true
        })
        this.$store.commit(mutationTypes.setManualSelectedStreet, {
          id: id,
          value: true
        })
        this.$store.commit(mutationTypes.setCity, {
          id: id,
          rout_id: null,
          text: '',
          ref: null
        })
      }
      this.clearSelectedRoute();
    },
    listSelectedCity(id){
      if (!id){
        this.anotherAddress.isManualSelectedCity = false;
      } else {
        this.$store.commit(mutationTypes.setManualSelectedCity, {
          id: id,
          value: false
        })
        this.$store.commit(mutationTypes.setStreet, {
          id: id,
          text: '',
        })
      }
      this.clearSelectedRoute(id);
    },
    clearSelectedRoute(id) {
      if (!id){
        this.anotherAddress.city = '';
        this.anotherAddress.select2City = '';
        this.anotherAddress.selectCityOptions = '';
        this.anotherAddress.city_ref = null;
        this.anotherAddress.route = '';
        this.anotherAddress.street = '';
      } else {
        const item = this.address.find(item => item.id === id)
        if (item) {
          item.city = '';
          item.select2City = '';
          item.select2CityOptions = '';
          item.city_ref = null;
          item.route = '';
          item.street = '';
          item.select2Street = '';
          item.select2StreetOptions = '';
        }
      }
    },
    manualSelectedStreet(id) {
      if (!id) {
        this.anotherAddress.isManualSelectedStreet = true;
        this.clearSelectedStreet(id);
      } else {
        this.$store.commit(mutationTypes.setManualSelectedStreet, {
          id: id,
          value: true
        })
      }
    },
    listSelectedStreet(id) {
      if (!id) {
        this.anotherAddress.isManualSelectedStreet = false;
        this.clearSelectedStreet(id);
      } else {
        this.$store.commit(mutationTypes.setManualSelectedStreet, {
          id: id,
          value: false
        })
      }
    },
    clearSelectedStreet(id) {
      if (!id) {
        this.anotherAddress.street = '';
      } else {
        const item = this.address.find(item => item.id === id)
        if (item) {
          item.street = '';
        }
      }
    },
    setCityInput(id, value){
      this.$store.commit(mutationTypes.setCity, {
          id: id,
          rout_id: null,
          text: value,
          ref: null,
        })
    },
    setStreetInput(id, value){
      this.$store.commit(mutationTypes.setStreet, {
          id: id,
          text: value,
        })
    },
    setHouseInput(id, value){
      this.$store.commit(mutationTypes.setHouse, {
          id: id,
          text: value,
        })
    },
    setApartmentInput(id, value){
      this.$store.commit(mutationTypes.setApartment, {
          id: id,
          text: value,
        })
    },
  },
  computed: {
    ...mapGetters({
      address: getterTypes.address,
      isLoading: getterTypes.isLoading,
      isMore: getterTypes.isMore,
    }),
    allowedAppendAnotherAddress(){
      if (this.address !== null){
        return this.address.length - this.maxAddress < 5
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";
  @import "@/scss/mixins.scss";

  .address{
    padding-bottom: 35px;
    margin-bottom: 40px;
    border-bottom: 1px solid #e9e9e9;
    .fieldRequired{
      font-size: 10px;
    }
    &__remove{
      display: flex;
      justify-content: right;
      &__icon{
        padding: 0 10px 0 10px;
        cursor: pointer;
        &:hover{
          color: $danger;
        }
      }
    }
    &__addAnotherAddress{
      display: inline-flex;
      color: $bb-90;
      cursor: pointer;
      &__label{
        margin-left: 10px;
      }
      svg{
        height: 25px;
        width: 25px;
      }
    }
  }
  .addressLast{
    border-bottom: unset;
  }
  .form-label{
    font-size: 12px;
    color: $fi;
  }
  .labelAction{
    margin-top: 10px;
    font-size: 12px;
    color: $link;
    float: right;
    cursor: pointer;
    position: relative;
    z-index: 10;
  }

  .personal-section{
    margin-bottom: 8px;
    border: 1px solid #e9e9e9;
    border-radius: 4px;
    &__header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px;
      cursor: pointer;
      outline: none;
      &__icon{
        margin-right: 24px;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
      }
      &__label{
        flex-grow: 1;
        margin-right: 16px;
        font-size: 18px;
        color: $fd;
        @media only screen and (max-width: $max-width-small) {
          font-size: 12px;
        }
      }
    }
    &__body{
      padding: 20px 20px 40px 20px;
      button{
        margin-right: 15px;
        margin-bottom: 10px;
      }
    }
  }

  /deep/ .select2{
    width: 100% !important;
    .select2-selection{
      height: 38px;
      padding: 0 1rem;
      font-size: 1rem;
      font-weight: 400;
      border: 1px solid #d8d8d8;
      border-radius: 0.2rem
    }
  }
  /deep/ .select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 100%;
  }
  /deep/ .select2-container--default .select2-selection--single .select2-selection__rendered {
      line-height: 38px;
  }
  .select2custom {
    font-size: 1.5em !important;
  }
  .select2Label{
    display: inline-block;
    font-size: 1.4rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: #333333;
  }
  /deep/ .select2-container--default.select2-container--disabled .select2-selection--single {
    background-color: #e9ecef !important;
  }
</style>
<script setup>
</script>